<template>
    <router-view
        :smokescreen_controller="smokescreen_controller"
    />
</template>


<script setup>
    import {reactive}            from 'vue';
    import SmokescreenController from '@/js/Settings/Smokescreen/SmokescreenController';

    const smokescreen_controller = reactive(new SmokescreenController());
</script>